import { useState } from "react";
import TypeIcon from "@components/Location/TypeIcon";
import DebugLocationPopup from "@components/Debug/LocationPopup";
import Dialog from "@hudson/ui/components/Dialogs/Simple";
import MinorButton from "@hudson/ui/components/FormFields/ButtonMinor";
import HtmlLabel from "@hudson/ui/components/FormFields/HtmlLabel";
import useContent from "@lib/use_content";

function Location({
  location,
  shiftLeft,
  flip,
  hideString,
  horizontal,
  small,
}: {
  hideString?: boolean;
  location: be.Location;
  shiftLeft?: boolean;
  flip?: boolean;
  horizontal?: boolean;
  small?: boolean;
}): JSX.Element {
  const { data } = useContent(["beLocationStringLabel"]);
  const [showString, setShowString] = useState(false);

  let flex;
  if (horizontal) {
    flex = flip
      ? "flex-col justify-start xs:flex-row-reverse"
      : "flex-col justify-start xs:flex-row";
  } else {
    flex = flip ? "flex-row-reverse" : "flex-row";
  }

  return (
    <>
      {!hideString && (
        <Dialog
          key={(Math.random() + 1).toString(36).substring(7)}
          maxWidthClass="max-w-md"
          show={showString}
          onHide={() => setShowString(false)}
        >
          <HtmlLabel text={location.string} />
        </Dialog>
      )}
      <div className={`relative flex space-x-3 pr-3 ${flex} `}>
        <div
          className={`pt-0 pb-1 pr-2 ${shiftLeft ? "pl-4" : "pl-2"} ${flip ? "ml-3" : "mr-1"} ${
            horizontal ? "hidden xs:flex" : "flex"
          } items-center justify-center rounded-lg bg-gradient-to-tl from-[--primary-color] via-[--primary-color] via-5% to-[--primary-color-darker]`}
        >
          {location.typeString && (
            <TypeIcon
              className={`${
                small ? `h-5 ${shiftLeft ? "w-7" : "w-10"} mt-0.5` : "h-10 w-10 mt-1.5"
              } `}
              color="white"
              type={location.typeString}
              typeKey={location.type}
            />
          )}
        </div>
        <div className="min-w-0 flex-1 flex justify-between">
          <div className="self-center">
            <p className={`${small ? "text-sm" : "text-base"} font-bold text-gray-700`}>
              {location.displayName}
              <DebugLocationPopup label="?" location={location} className="inline-block ml-2" />
            </p>
            {location.displayAddress && (
              <p className={`${small ? "text-xs" : "text-sm"} text-gray-500`}>
                {location.displayAddress}
              </p>
            )}
            {!hideString && location.string && data?.content.beLocationStringLabel && (
              <MinorButton
                color="warning"
                icon={
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 64 64"
                    role="img"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                    className="w-3 h-3 mr-1"
                  >
                    <path
                      data-name="layer2"
                      fill="none"
                      stroke="currentColor"
                      strokeMiterlimit="10"
                      strokeWidth="6"
                      d="M30 62h32V2H2v32"
                      strokeLinejoin="round"
                      strokeLinecap="round"
                    ></path>
                    <path
                      data-name="layer1"
                      fill="none"
                      stroke="currentColor"
                      strokeMiterlimit="10"
                      strokeWidth="10"
                      d="M26 56V38H8m18 0L2 62"
                      strokeLinejoin="round"
                      strokeLinecap="round"
                    ></path>
                  </svg>
                }
                onClick={() => setShowString(true)}
                padding="px-2 py-1 mt-1"
              >
                {data?.content.beLocationStringLabel}
              </MinorButton>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default Location;
